import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/logo.jpg";

const Footer = () => {
  return (
    <footer className="bg-secondary text-secondary-foreground py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <img src={logo} alt="Tolstoï Serrurier" className="h-20 w-auto mb-4" />
            <p className="text-secondary-foreground/80">
              Serrurier professionnel à Villeurbanne et alentours. Intervention rapide 24h/7j.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Services</h3>
            <ul className="space-y-2 text-secondary-foreground/80">
              <li><Link to="/depannage-urgence" className="hover:text-primary transition-colors">Dépannage urgence</Link></li>
              <li><Link to="/ouverture-porte" className="hover:text-primary transition-colors">Ouverture de porte</Link></li>
              <li><Link to="/changement-serrure" className="hover:text-primary transition-colors">Changement de serrure</Link></li>
              <li><Link to="/reparation-serrure" className="hover:text-primary transition-colors">Réparation de serrure</Link></li>
              <li><Link to="/volet-roulant" className="hover:text-primary transition-colors">Volet roulant</Link></li>
              <li><Link to="/porte-blindee-garage" className="hover:text-primary transition-colors">Porte blindée & garage</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3 text-secondary-foreground/80">
              <li className="flex items-center gap-2">
                <Phone className="h-5 w-5 text-primary flex-shrink-0" />
                <a href="tel:0482531608" className="hover:text-primary transition-colors">04 82 53 16 08</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-primary flex-shrink-0" />
                <a href="mailto:serruriertolstoi@gmail.com" className="hover:text-primary transition-colors">serruriertolstoi@gmail.com</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-5 w-5 text-primary flex-shrink-0 mt-1" />
                <span>Villeurbanne & Métropole de Lyon (69/01)</span>
              </li>
              <li className="pt-2">
                <Link to="/contact" className="inline-block px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors">
                  Formulaire de contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-foreground/20 pt-8 text-center text-secondary-foreground/70">
          <p>&copy; {new Date().getFullYear()} Tolstoï Serrurier. Tous droits réservés.</p>
          <p className="mt-2 space-x-4">
            <Link to="/mentions-legales" className="hover:text-primary transition-colors">
              Mentions légales
            </Link>
            <Link to="/urgence" className="hover:text-primary transition-colors text-xs opacity-80">
              Urgence
            </Link>
          </p>
          <p className="mt-2 text-sm">
            Créé par{" "}
            <a 
              href="https://www.createur-site-vitrine.fr/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-primary transition-colors underline"
            >
              Aerodrone Multiservices
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
